import React, { useEffect, useState } from "react";
import styles from "./NewUIPackages.module.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import imgNotFound from "../../../assets/images/single-image.png";
import NewUIPackageCard from "./NewUIPackageCard";
import Skeleton from "react-loading-skeleton";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

const NewUITopSellingPackages = ({ heading, button }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const itemsPerPage = 9;
  const [bookingData, setBookingData] = useState({});
  const [loader, setLoader] = useState(true);
  const location = useLocation();
  const [children, setChildren] = useState(0);
  const [childAge, setChildAge] = useState([]);
  const [showSendEnquiryPopup, setShowSendEnquiryPopup] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    const data = {
      location: params.get("location"),
      room: params.get("room"),
      adult: params.get("adult"),
      children: params.get("children"),
      radio: params.get("radio"),
      childAge: childAges,
    };
    setBookingData(data);
    fetchPackageData(data);
    setChildren(data.children);
    setChildAge(childAges);
  }, [location.search]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const clearSelection = () => {
    // console.log("Clearing selection...");
  };

  // Calculate start and end index of items to display
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const [packageData, setPackageData] = useState([]);
  // console.log(packageData, "packageData");

  const fetchPackageData = async (data) => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    const formdata = new FormData();
    formdata.append("limit", 8);
    formdata.append("guests", 10);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/holidays/fetch`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const result = await response.json();
      setLoader(false);
      setPackageData(result?.data);

      // const filteredData = result?.data?.filter(
      //   (item) => item.canBookable === 1
      // );
      // setPackageData(filteredData);
    } catch (error) {
      setPackageData([]);
      setLoader(false);
      console.error(error);
    }
  };
  const [markupData, setMarkupData] = useState(null);

  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );
          setMarkupData(findObject || null);
        } else {
          setMarkupData("No data found");
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchMarkup();
  }, []);


  return (
    <div className="container">
      <div className={styles.heading_div}>
        <h3 className='new_ui_heading'>{heading}</h3>
        <Link to={"/all-packages"} className={styles.view_all_btn}>
          View All
        </Link>
      </div>
      <div className='desktop_card_sec'>
        {loader ? (
          <div className="container flex align_items_center flex_wrap justify_content_center flex_gap_20 mt-30">
            {Array.from({ length: 6 }).map((items, index) => (
              <div
                key={index}
                // className="card-listing"
                className={styles.package_listing_card}
                style={{
                  background: "none",
                  marginBottom: "0px",
                  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  padding: "0px",
                }}
              >
                {/* <div> */}
                <Skeleton
                  height={200}
                />
                {/* </div> */}
                <div className="card_content" style={{ marginTop: "0px" }}>
                  <h6>
                    <Skeleton width="60%" />
                  </h6>
                  <h6>
                    <Skeleton width="40%" />
                  </h6>
                  <h6>
                    <Skeleton width="100%" />
                  </h6>
                  <Skeleton width="24%" />
                  <h6>
                    <Skeleton width="100%" height='40px' />
                  </h6>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={`${styles.package_flex} m_0`}>
            {packageData?.slice(0, 6)?.map((data, index) => (
              <NewUIPackageCard
                key={index}
                imgSrc={data?.featuredImage ? data?.featuredImage : imgNotFound}
                title={data.packageName}
                packageHub={data.packageHub}
                duration={data.totalDays}
                nightDuration={data.totalNights}
                price={data.startingPrice}
                bookingLink={data.bookingLink}
                detailsLink={data.detailsLink}
                packagehandle={data.packagehandle}
                canBookable={data?.canBookable}
                packageId={data.packageId}
                setShowSendEnquiryPopup={setShowSendEnquiryPopup}
                markupData={markupData}
                NoPax={data?.NoPax}
                packageItinerary={data?.packageItinerary}
              />
            ))}
          </div>
        )}
      </div>

      <div className='mobile_card_sec'>
        {loader ? (
          <div className="flex align_items_center flex_wrap justify_content_center flex_gap_20 mt-30">
            <div
              // className="card-listing"
              className={styles.package_listing_card}
              style={{
                background: "none",
                marginBottom: "0px",
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                padding: "0px",
              }}
            >
              {/* <div> */}
              <Skeleton
                height={200}
              />
              {/* </div> */}
              <div className="card_content" style={{ marginTop: "0px" }}>
                <h6>
                  <Skeleton width="60%" />
                </h6>
                <h6>
                  <Skeleton width="40%" />
                </h6>
                <h6>
                  <Skeleton width="100%" />
                </h6>
                <Skeleton width="24%" />
                <h6>
                  <Skeleton width="100%" height='40px' />
                </h6>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.package_flex}>
            <Swiper
              modules={[Pagination]}
              pagination={{ clickable: true }}
              loop={true}
              slidesPerView={1}
              className="mobile_card_slider"
            >
              {packageData?.slice(0, 6)?.map((data, index) => (
                <SwiperSlide key={index}>
                  <NewUIPackageCard
                    key={index}
                    imgSrc={data?.featuredImage ? data?.featuredImage : imgNotFound}
                    title={data.packageName}
                    packageHub={data.packageHub}
                    duration={data.totalDays}
                    nightDuration={data.totalNights}
                    price={data.startingPrice}
                    bookingLink={data.bookingLink}
                    detailsLink={data.detailsLink}
                    packagehandle={data.packagehandle}
                    canBookable={data?.canBookable}
                    packageId={data.packageId}
                    setShowSendEnquiryPopup={setShowSendEnquiryPopup}
                    markupData={markupData}
                    NoPax={data?.NoPax}
                    packageItinerary={data?.packageItinerary}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>

      {!loader && (
        <div className="newui_view_all_btn_mobile_div">
          <Link to={"/all-packages"} className="newui_view_all_btn_mobile">
            View All
          </Link>
        </div>
      )}

      {/* <div style={{ borderBottom: '0.5px solid #AAAAAA', paddingTop: '40px' }}></div> */}

    </div>
  );
};

export default NewUITopSellingPackages;
